export const SET_DEEPLINK_DATA = 'SET_DEEPLINK_DATA' as const;
export const RESET_DEEPLINK_DATA = 'CLEAR_DEEPLINK_DATA' as const;

export const setDeeplinkData = (data: unknown) => ({
  type: SET_DEEPLINK_DATA,
  payload: data,
});

export const resetDeeplinkData = () => ({
  type: RESET_DEEPLINK_DATA,
});
